<div class="container">
  <div class="container__form" [formGroup]="form">
    <div class="container__control-wrap">
      <kendo-formfield>
        <kendo-dropdownlist
          class="container__dropdown"
          formControlName="reportType"
          [defaultItem]="{ text: 'Choose report', value: null }"
          [itemDisabled]="itemDisabled"
          [data]="reportTypes"
          [valuePrimitive]="true"
          textField="text"
          valueField="value"
          #reportTypeDropdown
        >
        </kendo-dropdownlist>
      </kendo-formfield>
    </div>
  </div>
  <kendo-dialog-actions class="container__toolbar">
    <button
      kendoButton
      [primary]="true"
      class="rb-btn-medium action-btn"
      (click)="generateReport()"
      [disabled]="reportType.invalid || (reportGenerate$ | async)!.pending"
    >
      <span
        *ngIf="!(reportGenerate$ | async)!.pending; else generateReportLoading"
      >
        Generate Report
      </span>
      <ng-template #generateReportLoading>
        <kendo-loader
          [type]="'infinite-spinner'"
          [size]="'small'"
          class="loading-spinner"
        ></kendo-loader>
      </ng-template>
    </button>
  </kendo-dialog-actions>
</div>
